import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence, setPersistence } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyADxO3L6oq3RUzduUOTXtyoQCs5EhK9C14",
  authDomain: "beep-finance-newpilot.firebaseapp.com",
  projectId: "beep-finance-newpilot",
  storageBucket: "beep-finance-newpilot.firebasestorage.app",
  messagingSenderId: "501020148112",
  appId: "1:501020148112:web:fb959673a88ca7461cb315"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

// Enable persistent local storage for better token retention
const enablePersistence = async () => {
  try {
    // Try to use IndexedDB first (most reliable)
    await setPersistence(auth, indexedDBLocalPersistence);
    console.log('[Firebase] Using indexedDB persistence - tokens will be retained between sessions');
  } catch (e) {
    try {
      // Fall back to localStorage
      await setPersistence(auth, browserLocalPersistence);
      console.log('[Firebase] Using localStorage persistence - tokens should be retained between sessions');
    } catch (e2) {
      // Last resort - session only (will clear on tab close)
      await setPersistence(auth, browserSessionPersistence);
      console.log('[Firebase] Using sessionStorage persistence - tokens will be cleared when browser is closed');
    }
  }
};

// Set up persistence immediately
enablePersistence().catch(error => {
  console.error('[Firebase] Error setting persistence:', error);
  console.warn('[Firebase] Continuing with default persistence behavior');
});

// Export Firebase instances
export { app, analytics, auth };
